<template>
  <v-container id="cociliacoes-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <conciliacoes-data-table
          :conciliacoes="conciliacoes"
          :loading="loading"
          @rechargeTable="getConciliacoes()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getConciliacoes())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ConciliacoesService from '@/services/ConciliacoesService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      ConciliacoesDataTable: () => import('@/components/conciliacoes/ConciliacoesDataTable.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {
        conciliacoes: [],
        loading: false,
        processamentosExpirados: false,
        arrTour: [
          {
            element: '#btn-nova-conciliacao',
            intro: 'Clicando neste botão você poderá criar novas conciliações.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#conciliacoes-historico-search',
            intro: 'Neste campo você poderá pesquisar por conciliações já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-conciliacao',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua conciliação.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-edit-conciliacao',
            intro: 'Clicando neste ícone você poderá editar sua conciliação.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-conciliacao',
            intro:
              'Aqui você acessa outras opções para sua conciliação, como ver mais detalhes, executá-la novamente ou deletá-la.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.getConciliacoes();
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshConciliacoes', () => {
          this.getConciliacoes();
        });
      },

      getConciliacoes() {
        this.loading = true;

        ConciliacoesService.getConciliacoes(this.processamentosExpirados)
          .then((response) => {
            this.conciliacoes = [];
            response.data.conciliacoes.forEach((element) => {
              let parametros = this.getParametros(element);
              this.conciliacoes.push({
                id: element.id,
                nome: element.nome,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                status: element.status,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                flexibilidade: element.flexibilidade,
                tucSelecionada: element.tuc_selecionada,
                prioridades: parametros?.prioridadeBusca.join(', '),
                numeroRodadas: parametros?.rodadas.length,
                arquivoPartidaId: element.arquivo_contabil?.id,
                arquivoPartida: element.arquivo_contabil?.arquivo,
                arquivoReferenciaId: element.arquivo_fisico?.id,
                arquivoReferencia: element.arquivo_fisico?.arquivo,
                consultaPartida: element.consulta_contabil?.nome,
                consultaReferencia: element.consulta_fisico?.nome,
                totalConciliado: element.total_conciliado,
                sobrasPartida: element.total_sobra_contabil,
                sobrasReferencia: element.total_sobra_fisica,
                tipoConciliacao: element.tipo_conciliacao,
                atributosCoringa: parametros?.vazio == 'DIFNAN' ? true : false
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar conciliações.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            ((this.loading = false), this.iniciarTourPagina());
          });
      },

      getParametros(element) {
        let parametros;

        try {
          parametros = JSON.parse(element.parametros);
        } catch (e) {
          console.error(e);
          parametros = {
            tipo: {
              float: ['QTD', 'TUC', 'A2', 'A4', 'A3', 'A1', 'A5'],
              data: ['Data', 'DATA_CONEXAO'],
              str: ['Periodo', 'ODI']
            },
            vars: {
              DATA_CONEXAO_ORDENACAO: {
                partida: 'Data',
                referencia: 'DATA_CONEXAO'
              }
            },
            rodadas: [],
            regra: { var: 'DATA_CONEXAO_ORDENACAO', tipo: 'ALL' },
            prioridadeBusca: ['TUC', 'ODI', 'A2', 'A4', 'A3', 'A1', 'A5'],
            prioridadeOrdenacao: ['TUC', 'A2', 'A4', 'A3', 'A1', 'A5', 'Data', 'DATA_CONEXAO_ORDENACAO'],
            flexibilidadeConciliacao: { a: 'n', b: 'n' },
            vazio: 'TODOS'
          };
        }

        return parametros;
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.conciliacoes.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>
